// Detect mobile devices via user-agent so the app can adapt independently of
// viewport width. Wide phones (e.g. Pro Max-class handsets in landscape) can
// exceed the 600px mobile breakpoint while still being mobile devices, and
// width-only checks would leave them stuck on the desktop layout.
const MOBILE_UA_REGEX = /Android|iPhone|iPad|iPod|webOS|BlackBerry|Opera Mini|IEMobile/i;

export const isMobileDevice = (): boolean => MOBILE_UA_REGEX.test(navigator.userAgent);
